import _ from 'lodash'

const UUIDUtil = {
  guid: function guid() {
    function S4() {
      return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1)
    }

    return S4() + S4() + '-' + S4() + '-' + S4() + '-' + S4() + '-' + S4() + S4() + S4()
  }
}

class FormBuildEngine {
  constructor(componentConfigMap, widgetLayoutConfigList, editorConfigList) {
    this.componentConfigMap = {}
    this.widgetLayoutConfigList = []
    this.editorConfigList = []
  }

  // 静态方法
  static getInstance() {
    if (!FormBuildEngine.instance) {
      FormBuildEngine.instance = new FormBuildEngine()
    }
    return FormBuildEngine.instance
  }

  static normalizeMap(map) {
    return Array.isArray(map)
      ? map.map(function(key) {
        return { key: key, val: key }
      })
      : Object.keys(map).map(function(key) {
        return { key: key, val: map[key] }
      })
  }

  registerComponentConfigObject(componentConfig) {
    if (!this.componentConfigMap[componentConfig.componentType]) {
      this.componentConfigMap[componentConfig.componentType] = componentConfig
    } else {
      console.warn(
        '组件类型已经存在，这里是替换之前存在的组件，若为期望效果，请忽略此警告 ',
        this.componentConfigMap[componentConfig.componentType]
      )
      this.componentConfigMap[componentConfig.componentType] = componentConfig
    }
  }

  registerComponentConfig(componentType, widgetConfig, componentConfig, editorConfig) {
    // 组件配置
    const componentConfigObject = {
      componentType,
      widgetConfig,
      componentConfig,
      editorConfig
    }

    this.registerComponentObject(componentConfigObject)
  }

  // 根据类型获取组件配置
  getComponentConfigWithType(componentType) {
    const componentConfig = this.componentConfigMap[componentType]
    return componentConfig && _.cloneDeep(componentConfig)
  }

  registerWidgetLayoutConfigList(widgetLayoutConfigList) {
    this.widgetLayoutConfigList = widgetLayoutConfigList
  }

  /**
   * 获取组件配置
   */
  getWidgetLayouConfigWithComponentConfig() {
    const layoutConfig = this.widgetLayoutConfigList.map((widgetLayoutConfig) => {
      const widgetGroupConfig = {
        ...widgetLayoutConfig
      }
      widgetGroupConfig.groupWidgetList = widgetLayoutConfig.groupWidgetList
        .map((groupWidget) => {
          let componentConfig
          if (typeof groupWidget === 'string') {
            componentConfig = this.getComponentConfigWithType(groupWidget)
          } else if (groupWidget.componentType) {
            componentConfig = this.getComponentConfigWithType(groupWidget.componentType)
          }
          if (!componentConfig) {
            console.warn(
              `${groupWidget}`,
              ` 未找到指定的组件配置，故不显示在左侧列表中，如果需要，请注册组件配置`
            )
          }
          return componentConfig
        })
        .filter((componentConfig) => {
          return componentConfig
        })

      return widgetGroupConfig
    })

    return layoutConfig
  }

  registerEditorConfigList(editorConfigList) {
    this.editorConfigList = editorConfigList
  }

  getEditorConfigByType(editorConfigType) {
    return this.editorConfigList.find((itemConfig) => {
      return itemConfig.editorConfigType === editorConfigType
    })
  }

  getComponentEditorConfigByType(componentType, excludeTable) {
    const componentConfig = this.componentConfigMap[componentType]
    const componentEditorConfig = componentConfig.editorConfig
      .map((itemConfig) => {
        let editorConfigType = ''
        if (typeof itemConfig === 'string') {
          editorConfigType = itemConfig
        } else if (itemConfig.editorConfigType) {
          editorConfigType = itemConfig.editorConfigType
        }

        let tempEditorConfig = this.getEditorConfigByType(editorConfigType)

        if (tempEditorConfig) {
          tempEditorConfig = _.cloneDeep(tempEditorConfig)
        }

        return tempEditorConfig
      })
      .filter((tempEditorConfig) => {
        if (excludeTable) {
          return !(
            componentConfig.excludeEditorConfigInTable &&
            componentConfig.excludeEditorConfigInTable.includes(tempEditorConfig.editorConfigType)
          )
        }
        return tempEditorConfig
      })
    return componentEditorConfig
  }

  genenrateComponentConfigInContainer(componentConfig, componentType) {
    // this.formItemList[$event.newIndex] = JSON.parse(
    //   JSON.stringify(this.formItemList[$event.newIndex])
    // )
    // // 生成uuid
    // this.formItemList[$event.newIndex].componentConfig = {
    //   ...this.formItemList[$event.newIndex].componentConfig,
    //   uuid: UUIDUtil.guid(),
    //   componentType: this.formItemList[$event.newIndex].componentType
    // }

    return {
      ...componentConfig,
      uuid: UUIDUtil.guid(),
      componentType: componentType
    }
  }
}

FormBuildEngine.install = (Vue) => {
  Vue._formBuildEngine = FormBuildEngine.getInstance()
  Vue.prototype.$formBuildEngine = FormBuildEngine.getInstance()
}
export default FormBuildEngine

// if (!componentConfig.componentType && componentConfig.componentType instanceof String) {
//   throw new Error('组件配置的类型必须存在，且为字符串');
// } else if (!componentConfig.widgetConfig && componentConfig.widgetConfig instanceof Object) {
//   throw new Error('组件左侧配置相关的，图标, 文本，描述 必须存在且传入的对象需要时指定对象')
// } else if (!componentConfig.componentConfig && componentConfig.componentConfig instanceof Object) {
//   throw new Error('组件配置需要指定默认在中间显示的配置')
// } else if (!componentConfig.editorConfig && componentConfig.editorConfig instanceof Object) {
//   throw new Error('组件右侧显示的配置列表')
// } else if (!componentConfig.editorConfig && componentConfig.editorConfig instanceof Object) {
//   throw new Error('componentName 为必填')
// }
